import { defineStore } from 'pinia';

export const useUiStore = defineStore('ui', {
  state: () => ({
    isInternetConnected: false,
    shouldDisplayOffline: false,
    loadingState: false,
    errorLoadingState: false,
    triggerViewAs: false,
    // Route-specific loading states
    routeLoading: {
      isLoading: false,
      route: null,
      message: 'Loading...',
      error: null
    },
    globalError: {
      title: '',
      message: '',
      cta: ''
    },
    // Notification system
    notification: {
      show: false,
      type: 'success', // 'success', 'error', 'info', 'warning'
      title: '',
      message: '',
      timeout: 6000
    }
  }),

  actions: {
    setIsInternetConnected() {
      this.isInternetConnected = true;
    },
    setDisplayOfflineText(payload) {
      this.shouldDisplayOffline = payload;
    },
    setTriggerViewAs(payload) {
      this.triggerViewAs = payload;
    },
    setGlobalError(payload) {
      this.globalError = payload;
    },
    setLoadingState(payload) {
      this.loadingState = payload;
    },
    setErrorLoadingState(payload) {
      this.errorLoadingState = payload;
    },
    // Route loading actions
    startRouteLoading(route, message = 'Loading...') {
      this.routeLoading = {
        isLoading: true,
        route,
        message,
        error: null
      };
    },
    stopRouteLoading() {
      this.routeLoading = {
        isLoading: false,
        route: null,
        message: 'Loading...',
        error: null
      };
    },
    setRouteLoadingError(error) {
      this.routeLoading.error = error;
      this.routeLoading.isLoading = false;
    },
    updateRouteLoadingMessage(message) {
      this.routeLoading.message = message;
    },
    // Notification actions
    showNotification(payload) {
      this.notification = {
        show: true,
        type: payload.type || 'success',
        title: payload.title || '',
        message: payload.message || '',
        timeout: payload.timeout || 6000
      };
    },
    hideNotification() {
      this.notification.show = false;
    },
    // Convenience methods for specific notification types
    showSuccessNotification(title, message, timeout = 6000) {
      this.showNotification({ type: 'success', title, message, timeout });
    },
    showErrorNotification(title, message, timeout = 6000) {
      this.showNotification({ type: 'error', title, message, timeout });
    },
    showInfoNotification(title, message, timeout = 6000) {
      this.showNotification({ type: 'info', title, message, timeout });
    },
    showWarningNotification(title, message, timeout = 6000) {
      this.showNotification({ type: 'warning', title, message, timeout });
    }
  },

  getters: {
    getIsInternetConnected: (state) => state.isInternetConnected,
    getTriggerViewAs: (state) => state.triggerViewAs,
    getGlobalError: (state) => state.globalError,
    // Route loading getters
    isRouteLoading: (state) => state.routeLoading.isLoading,
    getRouteLoadingMessage: (state) => state.routeLoading.message,
    getRouteLoadingError: (state) => state.routeLoading.error,
    getCurrentLoadingRoute: (state) => state.routeLoading.route,
    // Notification getters
    getNotification: (state) => state.notification,
    isNotificationVisible: (state) => state.notification.show
  }
});
